export default __webpack_public_path__ + "static/cal1-527a314c8a85f942d5ced9513ed038dd.png";